import { XCircle } from "lucide-react";
import { Link } from "react-router-dom";

export const PaymentCancelled = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black text-white flex items-center justify-center">
    <div className="glass-card p-12 max-w-md mx-4 text-center">
      <XCircle className="w-16 h-16 text-red-400 mx-auto mb-6" />
      <h1 className="text-3xl font-bold mb-4">Payment Cancelled</h1>
      <p className="text-gray-300 mb-8">
        Your payment was cancelled and you have not been charged. If you'd like
        to try again, head back to the app.
      </p>
      <Link
        to="/app"
        className="inline-block bg-white text-black font-semibold px-8 py-3 rounded-full hover:bg-gray-200 transition-colors"
      >
        Go to App
      </Link>
    </div>
  </div>
);
